// Per-wallet "skip onboarding" flag. sessionStorage, not localStorage: skipping
// means "let me look around first", so it holds across refreshes in this tab,
// but a later visit offers setup again.
const SKIP_KEY_PREFIX = "stabletrust:onboardingSkipped:";

const keyFor = (address) => `${SKIP_KEY_PREFIX}${address.toLowerCase()}`;

export function isOnboardingSkipped(address) {
  if (!address) return false;
  try {
    return sessionStorage.getItem(keyFor(address)) === "true";
  } catch {
    return false;
  }
}

export function setOnboardingSkipped(address, skipped) {
  if (!address) return;
  try {
    if (skipped) sessionStorage.setItem(keyFor(address), "true");
    else sessionStorage.removeItem(keyFor(address));
  } catch {
    /* private mode */
  }
}
